import { render, staticRenderFns } from "./cmpHeader.vue?vue&type=template&id=55a4e8d2&scoped=true&"
import script from "./cmpHeader.vue?vue&type=script&lang=js&"
export * from "./cmpHeader.vue?vue&type=script&lang=js&"
import style0 from "./cmpHeader.vue?vue&type=style&index=0&id=55a4e8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a4e8d2",
  null
  
)

export default component.exports